<template>
  <div class="row">
    <el-dropdown class="dropdown" @command="themeFilter">
      <el-button type="normal" class="dropdown">
        {{tText}}
        <i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown" class="dropdown-menu">
        <el-dropdown-item command>所有题材</el-dropdown-item>
        <el-dropdown-item v-for="(v,i) in config" :key="i" :command="i">{{v[0]}}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-input
      @clear="getList"
      @keyup.enter.native="getList"
      ref="input"
      class="search"
      v-model="pdata.kw"
      clearable
      placeholder="请输入广告位名称/ID"
      :suffix-icon="pdata.kw.length>0?'':'el-icon-search'"
    ></el-input>
    <div class="col-3" style="margin-right:20px">
      <h3 style="margin:0">全部广告位</h3>
      <draggable class="list-group" :list="list1" group="people">
        <div
          class="list-group-item"
          v-for="(v, index) in list1"
          :key="index"
        >{{ v.name+'--'+ v.type_name}}</div>
      </draggable>
    </div>

    <div class="col-3 right">
      <h3 style="margin:0">已选广告位</h3>
      <draggable class="list-group" :list="mydata" group="people" @change="log">
        <div
          class="list-group-item"
          v-for="(v, index) in list2"
          :key="index"
        >{{ v.name+ '--'+v.type_name }}</div>
      </draggable>
    </div>
  </div>
</template>
<script>
import draggable from "vuedraggable";
import { sadfilter } from "../../api/api";

export default {
  display: "Two Lists",
  order: 1,
  components: {
    draggable
  },
  props: {
    mydata: {
      type: Array,
      default() {
        return [];
      }
    },
    myKw: {
      type: String,
      default() {
        return "";
      }
    },
    id: {
      type: String,
      default() {
        return "";
      }
    }
  },
  data() {
    return {
      list1: [],
      list2: this.mydata,
      config: this.$store.config.ad_space_type,
      tText: "请选择广告类型",
      pdata: {
        issued_app_id: this.id,
        type: "",
        kw: ""
      }
    };
  },
  watch: {
    "mydata.length": {
      handler(n, o) {
        this.list2 = this.mydata;
      },
      deep: true
      // immediate: true
    },
    myKw(val) {
      this.pdata = {
        app_id: "",
        type: "",
        kw: ""
      };
      // this.getList();
    },
    id(val) {
      this.pdata.issued_app_id = val;
      if (val) {
        this.getList();
      } else {
        this.list1 = [];
      }
    }
  },
  methods: {
    getList() {
      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      sadfilter(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.list1 = res.data;
        }
      });
    },
    log(e) {
      this.$emit("changeList", this.list2, true);
    },
    themeFilter(s) {
      this.tText = s === "" ? "请选择广告类型" : this.config[s][0];
      this.pdata.type = s === "" ? "" : this.config[s][1];
      this.getList();
    }
  },
  created() {},
  mounted() {
    this.getList();
    this.list2 = this.mydata;
  }
};
</script>
<style scoped>
.row {
  background: #f2f6fc;
  padding: 20px;
}
.list-group {
  width: 250px;
  height: 400px;
  overflow: auto;
  box-sizing: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  background: #fff;
}
.list-group-item {
  box-sizing: border-box;
  padding: 0 10px;
  background-color: #fff;
  /* margin-bottom: -1px; */
  display: block;
  position: relative;
  /* border-top: 1px solid rgba(0, 0, 0, 0.125); */
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
.col-3 {
  display: inline-block;
  vertical-align: top;
}
.right {
  float: right;
}
</style>



// WEBPACK FOOTER //
// TransWin2.vue?0784755b